import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@swagup-com/components';
import { useHistory } from 'react-router-dom';
import { Helmet } from '../shared';
import tags from '../../apis/seoTags';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 80,
    paddingBottom: 140
  },
  error: { color: theme.palette.error.main },
  image: {
    width: 296
  },
  title: {
    fontSize: 24,
    lineHeight: 1.33,
    letterSpacing: 'normal'
  },
  subtitle: {
    fontSize: 14,
    color: '#787b80',
    lineHeight: 1.57,
    letterSpacing: 'normal',
    marginTop: 8
  },
  backButton: {
    height: 'unset',
    padding: '22px 32px'
  }
}));

const ErrorFound = ({ error, resetErrorBoundary }) => {
  const classes = useStyles();

  const history = useHistory();

  return (
    <div className={classes.root}>
      <Helmet tags={tags.error} />
      <Grid container direction="column" alignItems="center" spacing={4}>
        <Grid item>
          <img src="/images/error/group-137.png" alt="Confirmed" className={classes.image} />
        </Grid>
        <Grid item style={{ textAlign: 'center' }}>
          <Typography variant="body1" role="alert" className={classes.error}>
            {error?.message}
          </Typography>
          <Typography variant="h1" role="alert" className={classes.title}>
            Houston, we have a problem
          </Typography>
          <Typography variant="h2" className={classes.subtitle}>
            We&apos;ve logged this issue and are working on it
          </Typography>
        </Grid>
        <Grid item>
          <Button variant="primary" onClick={resetErrorBoundary || history.goBack} className={classes.backButton}>
            Back to previous page
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default ErrorFound;
